import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { FilterSelectNative } from '@/components/custom/filter';
import QuizCard from './QuizCard';
import { useSurvey } from '@/hooks/useSurvey';
import { useClient } from 'jsonapi-react';
import Modal from '../../app/components/Modal';
import { SurveyForm } from './SurveyForm';
import { EmptyState } from '@/components/custom/empty-state';
import usePermission from '@/hooks/usePermission';
import { Loader } from '@/components/custom/loader';
import { useTranslation } from 'react-i18next';
import { DashboardContent } from '@/layouts/dashboard';

export default function Quiz(props) {
  const { uri } = props;

  const { t } = useTranslation();
  const { getSurvey, deleteSurvey, surveys, loading } = useSurvey();
  const client = useClient();
  const [showModal, setShowModal] = useState(false);
  const [activeSurvey, setActiveSurvey] = useState(null);
  const [relationshipsLoading, setRelationshipsLoading] = useState(true);

  const [relationships, setRelationships] = useState({
    courses: []
  });

  const filters = useFormik({
    initialValues: {
      course: 'blank'
    }
  });

  const getRelationships = async () => {
    const { data: courses } = await client.fetch('courses/simple');

    setRelationships({
      courses: courses || []
    });
    setRelationshipsLoading(false);
  };

  useEffect(() => {
    getRelationships();
  }, []);

  useEffect(() => {
    getSurvey(filters.values);
  }, [filters.values]);

  const reverseSurveys = surveys.reverse();

  const breadcrumbs = {
    title: 'Ferramentas de Avaliação',
    nav: [
      {
        route: uri,
        name: 'Questionário de Percepção',
        isActive: true
      }
    ]
  };

  return (
    usePermission('Visualizar respostas e dados', 'Questionário de Percepção') && (
      <DashboardContent
        variant="plain"
        className="animate-fade-in"
        breadcrumbs={breadcrumbs}
      >
        <div className="filter-bar">
          <FilterSelectNative
            label={t('filter.labelSelectCourse')}
            value={filters.values.course}
            onChange={e => filters.setFieldValue('course', e.target.value)}
            options={relationships.courses.map(o => ({
              id: o.id,
              name: o.title
            }))}
          />

          {usePermission('Criar questionários', 'Questionário de Percepção') && (
            <button
              type="button"
              onClick={() => setShowModal(true)}
              className="btn btn--primary btn--wide"
            >
              {t('nps.buttonNewQuiz')}
            </button>
          )}
        </div>

        {loading && <Loader />}

        {reverseSurveys.length === 0 && !loading ? (
          <div className="center-empty-state">
            <EmptyState
              type="content"
              title={t('emptyState.noQuest')}
            />
          </div>
        ) : (
          <div className="tab__cards">
            {reverseSurveys.map((survey, i) => (
              <QuizCard
                relationshipsLoading={relationshipsLoading}
                relationships={relationships}
                activeSurvey={activeSurvey}
                key={i}
                survey={survey}
                onDelete={() => deleteSurvey(survey.id)}
              />
            ))}
          </div>
        )}

        <Modal
          show={showModal}
          onClose={() => {
            setShowModal(false);
            setActiveSurvey(null);
          }}
        >
          <SurveyForm
            relationshipsLoading={relationshipsLoading}
            relationships={relationships}
            activeSurvey={activeSurvey}
            onClose={() => {
              setShowModal(false);
              setActiveSurvey(null);
            }}
          />
        </Modal>
      </DashboardContent>
    )
  );
}

export * from './QuizData';
export * from './QuizData/QuizDataProposal';
export * from './QuizData/QuizDataOpenAnswers';
export * from './QuizCreate';
